<template>
    <div id="area-setting">
        <div class="second-header-wrap">
            <el-button type="default" @click="$router.back()" size="medium">返回</el-button>
            <school-year-selector @change="getVoteTwoTempListFunc"></school-year-selector>
            <el-button type="primary" @click="jumpToPage('templateAdd')" size="medium" v-if="isSelectedYearCurrent">新增模板</el-button>
        </div>
        <div class="main-wrap custom—scrollbar">
            <div class="main-container">
                <ul class="week-list" v-if="templateList && templateList.length !== 0">
                    <li @click="jumpToPage('templateDetail', {id: templateItem.id})" v-for="(templateItem, index) in templateList" :class="['template-item', templateItem.status !== 1 ? '' : 'template-item--grey']">
                        <div class="template-item__tag" v-if="templateItem.voteStatus === 1">草稿</div>
                        <div class="template-item__info">
                            <div>
                                <span class="template-item__number">{{templateItem.voteTitle}}</span>
                                <template  v-if="isSelectedYearCurrent">
                                    <i v-if="templateItem.voteStatus === 1" class="el-icon-edit" style="color: #409EFF;" @click.stop="jumpToPage('templateEdit', {id: templateItem.id})"></i>
                                    <i class="el-icon-delete" style="color: #F56C6C;" @click.stop="deleteHandler(templateItem.id)"></i>
                                </template>

                            </div>
                        </div>
                    </li>
                </ul>
                <default-page v-else mes="暂无模板"></default-page>
            </div>
        </div>
    </div>
</template>

<script>
    import SchoolYearSelector from '@/components/SchoolYearSelector';
    import DefaultPage from '@/components/DefaultPage';
    import {getVoteTwoTempList, delVoteTwoById} from '@/api/setting';
    import baseMixin from '@/mixins/baseMixin';
    import mixins from '@/mixins/windowResize';
    import {mapGetters} from 'vuex';

    export default {
        name: "templateList",
        data() {
            return {
                templateList: [],
                mainContainerHeight: 0,
            }
        },
        mixins: [baseMixin, mixins],
        created() {
            this.getVoteTwoTempListFunc();
        },
        computed: {
            ...mapGetters(['isSelectedYearCurrent']),
        },
        components: {DefaultPage, SchoolYearSelector},
        mounted() {
            this.mainContainerHeight = `${window.innerHeight - 337}px`;
        },
        methods: {
            getVoteTwoTempListFunc() {
                getVoteTwoTempList({
                    voteTitle: ''
                })
                    .then(res => res.data)
                    .then(data => {
                        this.templateList = data.data;
                    })
            },
            deleteHandler(id) {
                this.$confirm('删除后该模板创建的招生将无法报名，是否确认删除?', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delVoteTwoById({
                        voteId: id
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                const _this = this;
                                _this.$message({
                                    message: '删除成功！' ,
                                    type: 'success',
                                    duration: 1000,
                                    onClose: function () {
                                        _this.getVoteTwoTempListFunc();
                                    }
                                });

                            }
                        })

                }).catch(() => {
                });

            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin.scss";

    @include reset-global;

    .second-header-wrap {
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        background-color: #fff;
        z-index: 1000;
    }
    .main-wrap {
        width: 100%;
    }

    .main-container {
        width: 1320px;
        margin: 0 auto;

        padding: 0 10px;
        min-height: 560px;
    }

    .custom—scrollbar {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .custom—scrollbar::-webkit-scrollbar {
        width: 6px;
        background-color: rgba(255, 255, 255, 0.1);
    }

    .custom—scrollbar::-webkit-scrollbar-thumb {
        background-color: #999;
    }

    .custom—scrollbar::-webkit-scrollbar-track {
        background-color: rgba(255, 255, 255, 0.1);
    }

    .week-list {
        padding-top: 20px;
        padding-left: 20px;
        @include clearfix;
        .template-item {
            cursor: pointer;
            width: 19%;
            height: 130px;
            text-align: center;
            float: left;
            background: no-repeat center center / cover;
            background-image: url(https://cdnfile-10043692.file.myqcloud.com/teachingOnline/week-cover.jpg);
            margin-right: 1%;
            margin-bottom: 20px;
            box-shadow: 0 0 10px #777;
            position: relative;
            font-size: 14px;
            &.template-item--grey {
                filter: grayscale(100%);
            }
        }
        .template-item__tag {
            position: absolute;
            z-index: 1000;
            background-color: #f08080;
            font-size: 14px;
            padding: 2px 4px;
            right: 5px;
            top: 5px;
            color: #fff;
        }
        .template-item__info {
            background-color: rgba(0, 0, 0, 0.5);
            color: #fff;
            position: absolute;
            bottom: 0;
            padding: 2px;
            box-sizing: border-box;
            width: 100%;
            div {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }
            .el-icon-edit {
                top: 4px;
                position: absolute;
                right: 28px;
            }
            .el-icon-delete {
                top: 5px;
                position: absolute;
                right: 5px;
            }
        }
        .template-item__duration {
            font-size: 12px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/kindergarten/setting/TemplateList.vue